import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { resendEmailVerification, getUserProfile } from '../actions/users-profile-actions';
import { bindActionCreators } from 'redux'
import UserProfilePage from './UserProfilePage'
import { updateOrgProfile, updateOrgProfileReset } from '../../organizations/actions/organizations-actions';

const UserProfilePageContainer = (props) => {
  return (
    <UserProfilePage {...props} />
  )
}

const mapStateToProps = (state) => ({
  userAccountProfile: state.userProfile.accountUserProfile,
  adminOrgProfile: state.adminOrgProfile.results.data,
  manageAdminOrgUsersOutcome: state.manageAdminOrgUsersOutcome.results.data,
  editProfileOutcome: state.editProfile.results.data,
  userProfilePicture: state.thisUserProfilePicture.result,
  isMobileView: state.mobileViewMode.isMobileView,
  paidFeatureAccess: state.userPrivileges.results.paidFeatureAccess,
  isOrgAdmin: state.isOrgAdmin.results,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getUserProfile,
      resendEmailVerification,
      updateOrgProfile,
			updateOrgProfileReset,
    },
    dispatch,
  )

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(UserProfilePageContainer))
